import ApplicationController from './application'

export default class extends ApplicationController {

  static targets = [ 'input', 'submitButton' ]

  // ==== Actions

  digit(event) {
    const value = event.target.value

    /** Paste or autofill of the full code: spread digits across the boxes */
    if (value.length > 1) {
      const digits = value.replace(/\D/g, '').slice(0, this.inputTargets.length).split('')
      this.inputTargets.forEach((input, i) => input.value = digits[i] || '')
      ;(this.inputTargets[digits.length] || this.lastInput).focus()
    } else if (value) {
      this.next(event.target)?.focus()
    }

    if (this.inputTargets.every(input => input.value)) this.submitButtonTarget.click()
  }


  navigate(event) {
    if (event.key !== 'Backspace' || event.target.value) return
    this.previous(event.target)?.focus()
  }

  // ==== Private

  next(input) {
    return this.inputTargets[this.inputTargets.indexOf(input) + 1]
  }


  previous(input) {
    return this.inputTargets[this.inputTargets.indexOf(input) - 1]
  }


  get lastInput() {
    return this.inputTargets[this.inputTargets.length - 1]
  }

}
